module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/red-2ab53099f5c601046f6be12b5e43b53a.png";